export const AUTH_TOKEN = process.env.AUTH_TOKEN_NAME;
export const COUNTRY_OF_RESIDENCE = 'eq_country_of_residence';
export const IP_COUNTRY = 'eq_country';
export const HAS_CLEARED_INTERCOM = 'eq_has_cleared_intercom';
export const UTM_SOURCE = 'eq_utm_source';
export const UTM_MEDIUM = 'eq_utm_medium';
export const UTM_CAMPAIGN = 'eq_utm_campaign';
